import type { JSX } from 'react'

import type { RenderPlaceholderProps } from 'slate-react'

import { BookTextIcon, Button, Text } from '@buffer-mono/popcorn'

import styles from '~publish/legacy/composer/composer/editor/ComposerEditor/ComposerEditor.module.css'

export const TEMPLATES_NUDGE_PLACEHOLDER = 'Start writing or get inspired with'
export const TEMPLATES_NUDGE_ARIA_PLACEHOLDER = `${TEMPLATES_NUDGE_PLACEHOLDER} Templates`

export type TemplatesNudgePlaceholderProps = RenderPlaceholderProps &
  Readonly<{
    onOpenTemplates: () => void
    templatesButtonLabel?: string
    templatesPanelId?: string
    templatesPanelOpen?: boolean
  }>

export function TemplatesNudgePlaceholder({
  attributes,
  children,
  onOpenTemplates,
  templatesButtonLabel = 'Templates',
  templatesPanelId,
  templatesPanelOpen,
}: TemplatesNudgePlaceholderProps): JSX.Element {
  return (
    <Text color="subtle" {...attributes} className={styles.placeholder}>
      <span className={styles.placeholderText} data-text={children} />
      <Button
        className={styles.templatesButton}
        variant="tertiary"
        size="small"
        aria-label={templatesButtonLabel}
        aria-controls={templatesPanelId}
        aria-expanded={templatesPanelOpen}
        onClick={onOpenTemplates}
      >
        <BookTextIcon />
        <span className={styles.templatesLabel} data-text="Templates" />
      </Button>
    </Text>
  )
}
